<template>
  <exception-page type="403" />
</template>

<script>
import ExceptionPage from "./ExceptionPage";

export default {
  name: "e403",
  components: {
    ExceptionPage,
  },
};
</script>

<style scoped></style>
